import React, {useEffect} from 'react';
import classnames from 'classnames/bind';
import {IBreadCrumb, ICountry, IState, Replacement} from '../../interface';
import style from './index.module.scss';
import Breadcrumb from '../Breadcrumb';
import Header from '../Header';
import FindTheRightOil from '../FindTheRightOil';
import {connect} from 'react-redux';
import localesReplacement from '../../utils/localesReplacement';
import useURLParameter from '../../hooks/use-url-parameter';
import {isOnlyWTBcountry} from '../../utils/isOnlyWTBcountry';
import {useSearchParams} from 'react-router-dom';
import _ from 'lodash';
import { useAppName } from '../../hooks/use-app-names';
import { APPNAME, FASTSCAN, PRESERVED } from '../../constants';
import { useSearchState } from '../../hooks/use-search-state';
import { PageType } from '../../interface/emnu';

const cx = classnames.bind(style);

export interface Props {
  countries: ICountry[];
  replacements: Replacement;
  country: ICountry;
}

export const Landing = (props: Props) => {
  const {replacements, countries, country: currentCountry} = props;
  const isFastScan = useAppName(FASTSCAN);
  const isPreserved = useSearchState(PRESERVED);
  const {countryIsoCode} = useURLParameter(location.pathname, countries, []);
  const [searchParams, setSearchParams] = useSearchParams();
  const i18n = (localStorage.getItem('languageCode') ||
    process.env.REACT_APP_LANGUAGECODE) as string;
  const country = countryIsoCode
    ? countryIsoCode
    : ((localStorage.getItem('countryCode') ||
        process.env.REACT_APP_COUNTRYCODE) as string);
  const breadcrumb: IBreadCrumb[] = [
    {
      value: 'Castrol',
      href: '#',
      static: true,
    },
    {
      value: 'Product Finder',
      href: '#',
      static: true,
    },
    {
      value: 'Recommended oils',
      static: true,
    },
  ];
  const window:any=globalThis;
  window.dataLayer = window.dataLayer || [];

  const onVehicleSelect = (value: string | number, model?:string) => { //value=18f847ba17864033e0659fbab47aa869
    window.dataLayer.push({
      'event' : 'viewRecommendedOilsClick',
      'pageType' : PageType.ProductFinder,
      'buttonName' : 'view recommended oils',
      'searchType' : localStorage.getItem('searchTab') === 'Vehicle search'? 'vehicle search':'quick search',
      'vehicleModel' : model,
      'countryCode' :localStorage.getItem('countryCode')
  });

    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  const onProductSelect = (value: string | number,product? :string) => {
    window.dataLayer.push({
      'event' : 'viewProductPageClick',
      'pageType' : PageType.ProductFinder,
      'searchType' : 'oil search',
      'buttonName' : 'view product page',
      'oilName' : product,
      'countryCode' :localStorage.getItem('countryCode')
})

    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  const onWTBClick = () => {
    window.dataLayer.push({
      'event' : 'whereToBuyClick',
      'pageType' : PageType.ProductFinder,
      'buttonName' : 'where to buy',
      'countryCode' :localStorage.getItem('countryCode')
});

    searchParams.set('page', 'wheretobuy');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  useEffect(() => {
    if (currentCountry.isoCode && isOnlyWTBcountry(currentCountry.isoCode)) {
      searchParams.set('page', 'wheretobuy');
      isFastScan && searchParams.set(APPNAME, FASTSCAN);
      setSearchParams(searchParams);
    }
    localStorage.setItem('searchTab','quick search')
  }, [currentCountry.isoCode]);
  return (
    <>
      {currentCountry.isoCode ? (
        <div className={cx('landing')}>
          <Header />
          <div className={cx('container')}>
            {/* Banner section */}
            <div className={cx('banner')}></div>
            {/* Breadcrumb and titie above banner */}
            <div className={cx('heading')}>
              <Breadcrumb dataList={breadcrumb} />
              <h2>{localesReplacement(replacements, 'Product Finder')}</h2>
            </div>
            {/* Main container */}
            <div className={cx('main-content')}>
              <FindTheRightOil
                country={country}
                onVehicleSelect={onVehicleSelect}
                onProductSelect={onProductSelect}
                onWTBClick={onWTBClick}
                i18n={i18n}
                locales={replacements}
                baseAPI={process.env.REACT_APP_PROVIDER_URL}
                restore={isFastScan}
                preserved={isPreserved}
              />
            </div>
          </div>
        </div>
      ) : (
        <Header />
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  countries: state.countries,
  replacements: state.replacements,
  country: state.country,
});

export default connect(mapStateToProps)(Landing);
